export default __webpack_public_path__ + "static/media/gs.b0e2c11c.jpg";